import type { NotificationGroupedDTO } from "@eu.mdotm.api/sphere";
import { atomWithStorage, useAtom } from "@mdotm/shadcn/legacy/reactivity";
import type { Updater } from "@mdotm/shadcn/legacy/utils";

export type NotificationMarker = {
	markAsRead: boolean;
	latestPortfolioPool: NotificationGroupedDTO[];
	latestMarketPool: NotificationGroupedDTO[];
};

export const notificationMarkerDefault: NotificationMarker = {
	latestMarketPool: [],
	latestPortfolioPool: [],
	markAsRead: false,
};

export const notificationCenter$ = atomWithStorage<NotificationMarker>(
	"notificationCenterAtom",
	notificationMarkerDefault,
);

export function useNotificationCenterState(): {
	notificationCenterStatus: NotificationMarker;
	setNotificationCenterStatus: (newValue: NotificationMarker | Updater<NotificationMarker>) => void;
	reset(): void;
} {
	const [notificationCenterStatus, setNotificationCenterStatus] = useAtom(notificationCenter$);
	return {
		notificationCenterStatus,
		setNotificationCenterStatus,
		reset: () => setNotificationCenterStatus(notificationMarkerDefault),
	};
}
